import styled from "styled-components";

export const MainWrapperContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const MainWrapper = styled.div`
  width: 100%;
  padding: 18px 0px 20px 0px;
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  scroll-behavior: smooth;
  position: relative;
`;

export const SingleTemplate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.isSelected ? "blue" : "#9e9e9e")};
  gap: 8px;
  max-width: 90px;
  min-width: 90px;
`;

export const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  display: flex;
  align-items: center;
  padding: 5px;

  background: white;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  &:hover {
    background: #eee;
  }

  &.left {
    left: 10px;
  }

  &.right {
    right: 10px;
  }
`;

export const SingleTemplatePreviewWrapper = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
`;

export const SingleTemplatePreview = styled.div`
  border: 1px solid ${(props) => (props.isSelected ? "blue" : "#eeeeee")};
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0px 1px 4px #c7c7c7b5;
  &:hover {
    box-shadow: 3px 2px 5px #c7c7c7b5;
  }
  transition: all 0.3s ease-in;
`;

export const TemplateLabel = styled.div`
  text-align: center;
  height: 20px;
`;
